import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'bom-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {
  @Input()
  title: string;

  @Input()
  expanded: boolean;

  @Input()
  progressText: string;

  @Input()
  badge?: {
    text?: string;
    type?: string;
    size?: string;
  };

  @Output()
  toggleExpand = new EventEmitter<boolean>();

  onToggleExpand() {
    this.toggleExpand.emit(!this.expanded);
  }
}
